import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { matchPossibleCollaborators } from '@utils/ideaFilters';

import { Idea } from '../../../../../models/Sessions/Idea/Idea';
import { Participant } from '../../../../../models/Sessions/Participant';
import { Session } from '../../../../../models/Sessions/Session';
import { BusService } from '../../../../../services/bus.service';
import { EventsService } from '../../../../../services/events.service';
import { TrackingService } from '../../../../../services/tracking/tracking.service';

@Component({
  selector: 'app-add-collaborator-modal',
  templateUrl: './add-collaborator-modal.component.html',
  styleUrls: ['./add-collaborator-modal.component.scss'],
})
export class AddCollaboratorModalComponent implements OnInit {
  @Input() session: Session;
  @Input() idea: Idea;

  filteredList: Participant[];
  selectedParticipant: Participant;

  constructor(
    public activeModal: NgbActiveModal,
    private bus: BusService,
    private events: EventsService,
    public modalService: NgbModal,
    private trackingService: TrackingService,
  ) {}

  onKey(value: string) {
    this.filteredList = this.filterCollaborators(value);
  }

  // filter by collaborator.user.name
  filterCollaborators(query) {
    const q = query.toLowerCase();
    return this.possibleCollaborators.filter(el => {
      return (
        el.user &&
        ((el.user.name && el.user.name.toLowerCase().indexOf(q) > -1) ||
          (el.user.first_name &&
            el.user.first_name.toLowerCase().indexOf(q) > -1) ||
          (el.user.organization &&
            el.user.organization.toLowerCase().indexOf(q) > -1) ||
          el.user.email.toLowerCase().indexOf(q) > -1)
      );
    });
  }

  onSelect(participant) {
    this.selectedParticipant = participant;
  }

  get possibleCollaborators() {
    return this.session.config.participants
      .filter(p => p.user && p.user.registered)
      .filter(p => p.user.email !== 'vgamper@gmail.com')
      .filter(p => matchPossibleCollaborators(p, this.idea))
      .sort((a, b) => {
        if (a.user && b.user) {
          return ('' + a.user.name).localeCompare('' + b.user.name);
        }
        return 0;
      });
  }

  close() {
    this.activeModal.close();
  }

  closeAndAddCollaborator() {
    const payload = { participant_id: this.selectedParticipant._id }; // somehow that is what the API expects
    this.bus.publish(
      this.events.requested.action.session.idea.addCollaborator,
      payload,
      this.idea,
      this.session,
    );

    this.bus.publish(
      this.events.requested.action.tracking.track,
      this.session,
      'idea',
      'addCollaborator',
      this.idea._id,
    );

    this.close();
  }

  ngOnInit(): void {
    this.filteredList = this.possibleCollaborators;
  }
}
